import React, { useContext } from 'react';
import { QuestionToAsk, PrintPage, ReturnToHome } from '../../components';
import userContext from '../../components/ContextComponent/UserContext';

function GenericErrorForStage2({ apiOutput }) {
    const { formData } = useContext(userContext);

    return (
        <>
            <div className="col-xs-12 pad-4-t text-align-center">
                <p>Thank you {formData.firstName}! Your application is being processed.</p>
            </div>
            <div className="col-xs-12 pad-2 text-align-center">
                <p>Application Reference No. {apiOutput.go2ApiPcnNumber}</p>
            </div>
            <div className="col-xs-12 text-align-center">
                <p>We will review your application and contact you if we need additional information.</p>
            </div>
            <div className="col-xs-12 text-align-center">
                <div className="pad-4-t">
                    <ReturnToHome apiOutput={apiOutput} />
                    <PrintPage />
                    <QuestionToAsk />
                </div>
            </div>
        </>
    );
}

export default GenericErrorForStage2;